import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import food1 from "../Images/food1.jpg";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  // 

export default function Food() {
  return (
    <>
      <SEO  // 
        title="AI ERP & CRM for Food & Beverage Industry | EnteliPro"
        description="EnteliPro offers AI-powered ERP and CRM solutions for food and beverage businesses. Manage production, quality control, supply chain, and compliance with intelligent automation."
        keywords="Food ERP Software, AI CRM for Food Industry, Beverage Management Software, Food Safety Compliance, Production Management, Food Supply Chain ERP"
        canonical="https://www.entelipro.com/Food"
        ogImage="https://www.entelipro.com/static/media/food1.jpg"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">  {/*  - <a> to <Link> */}
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Food Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={food1}
                  alt="EnteliPro AI ERP for Food Processing and Beverage Industry"  // 
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>  
                  AI ERP & CRM for Food & Beverage Industry
                </h1>
                <p className="para">
                  The food industry comprises processing, preservation,
                  conversion, and preservation of eatable items. The raw
                  material for the food industry is obtained from the
                  agriculture industry. EnteliPro delivers intelligent ERP solutions
                  tailored for food processing and beverage companies.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <p className="para">
                      The food industry has grown exponentially in the past
                      decade and industry delivers high quality standards at the
                      best possible price.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      Constantly increasing market demands require standardized
                      processes from purchasing to production and sales to run smoothly.
                    </p>
                  </div>
                </div>
              </div>
              <div className="left-text">
                <h3>AI ERP & CRM For Food Industry</h3>
                <p className="para">
                  {`${project_name}`} solutions help to create standardized and
                  clearly defined processes. All information that used to be
                  stored separately is now kept in one place, which makes
                  searching for it that much easier.
                </p>
                <br />
                <p className="para">
                  Your sales staff benefits from centrally stored information.
                  Your sales team is always well informed and can access the
                  in-house database directly from their mobile devices. This
                  system saves your company time and money.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-specification-6 food-tight">
        <div className="specification-layout">
          <div className="container">
            <div className="main-titles-head">
              <h3 className="header-name">
                We Bring The Best Features For Food Industry
              </h3>
            </div>
            <div className="specification-effect row text-center">
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <span className="fa fa-tachometer" aria-hidden="true"></span>
                  <h4>
                    <Link to="/dashboardandreporting" className="title-head">
                      Dashboard
                    </Link>
                  </h4>
                  <p className="para">
                    EnteliPro CRM provides you with focused promotional activities
                    which is an excellent way to introduce your product to the
                    market.
                  </p>
                </div>
              </div>
              <div className=" grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <span className="fa fa-tasks" aria-hidden="true"></span>
                  <h4>
                    <Link to="/taskmanagement" className="title-head">
                      Managing Tasks
                    </Link>
                  </h4>
                  <p className="para">
                    With EnteliPro CRM get campaigns based on your business goals
                    will create a brand identity and positive brand
                    association.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <span className="fa fa-file-text" aria-hidden="true"></span>
                  <h4>
                    <Link to="/docmangement" className="title-head">
                      Managing Documents
                    </Link>
                  </h4>
                  <p className="para">
                    EnteliPro 360 degrees customer view strategic approach enabling
                    businesses to offer the best customer experience across all
                    channels.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1">
                <div className="back-color">
                  <span className="fa fa-mobile" aria-hidden="true"></span>
                  <h4>
                    <Link to="/digitalmobile" className="title-head">
                      Mobile Access To Data
                    </Link>
                  </h4>
                  <p className="para">
                    Utilize the amazing technology where ever you are to
                    benefits your business. View data and receive valuable
                    alerts on mobile.
                  </p>
                </div>
              </div>
              <div className=" grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1">
                <div className="back-color">
                  <span className="fa fa-database" aria-hidden="true"></span>
                  <h4>
                    <Link to="/leadmanagement" className="title-head">
                      Lead Capture Forms
                    </Link>
                  </h4>
                  <p className="para">
                    Works best for you that will determine and pursue your
                    business marketing goals. Boost visibility and increase
                    sales while sustaining a profit.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1 ">
                <div className="back-color">
                  <span className="fa fa-line-chart" aria-hidden="true"></span>
                  <h4>
                    <Link to="/salesforecasting" className="title-head">
                      Visualize Your Sales Process
                    </Link>
                  </h4>
                  <p className="para">
                    Get high-level overview of your entire business that will
                    develop a better understanding of the effective business
                    planning process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}